import React from 'react';
import {
  func, oneOfType, shape, string, node, bool, number,
  oneOf,
} from 'prop-types';
import { ProductImage } from '@thd-olt-component-react/product-pod';
import { CardMedia, TileMedia } from '@one-thd/sui-atomic-components';

export const Image = ({
  variant = 'default',
  pod = {}
}) => {
  if (variant === 'product') {
    // <ProductPod>
    //   {slot}
    // </ProductPod>
    return (
      <ProductImage
        itemId={pod.itemId}
        showSecondaryImage={pod.showSecondaryImage}
        dualImageSwipe={pod.dualImageSwipe}
      />
    );
  }

  if (variant === 'card') {
    // <Card>
    //   <CardContent>
    //     {slot}
    //   </CardContent>
    // </Card>
    return (
      <CardMedia
        aspect={pod.aspect}
        padding={pod.padding}
        src={pod.src}
        // string
        width={pod.width}
        alt={pod.altText}
        style={{ height: pod.height }}
      >
        {pod.children}
      </CardMedia>
    );
  }

  if (variant === 'tile') {
    // <Tile>
    //   <TileContent>
    //     {slot}
    //   </TileContent>
    // </Tile>
    return (
      <TileMedia
        // string
        height={pod.height}
        src={pod.src}
        swatch={pod.swatch}
      />
    );
  }

  return (
    <div className="sui-flex sui-justify-center product-image-wrapper">
      <img
        src={pod.src}
        alt={pod.altText}
        // number
        height={pod.height}
        // number
        width={pod.width}
        loading={pod.loading}
        // eslint-disable-next-line react/no-unknown-property
        fetchpriority={pod.fetchPriority}
      />
    </div>
  );
};

Image.propTypes = {
  variant: oneOf(['default', 'product', 'card', 'tile']).isRequired,
  pod: shape({
    // product
    itemId: string,
    showSecondaryImage: bool,
    dualImageSwipe: bool,
    // card
    aspect: string,
    padding: string,
    // default
    fetchPriority: string,
    loading: string,
    // tile
    swatch: bool,
    // shared (card + tile + default)
    src: string,
    altText: string,
    height: oneOfType([string, number]),
    width: oneOfType([string, number]),
    // exclusive (tile | card)
    children: oneOfType([func, node]),
  }).isRequired,
};
